/**
 * @generated SignedSource<<445bbb26999be3245ee0dbf46cb1b48e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GetHelpZendeskContactBuyer_viewer$data = {
  readonly transaction?: {
    readonly buyer: {
      readonly mcRedactionOpopAbTest: {
        readonly variant: string | null;
      } | null;
      readonly serviceId: string | null;
    } | null;
    readonly conversation: {
      readonly serviceId: string | null;
    } | null;
    readonly item: {
      readonly serviceId: string | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"ContactBuyerForm_transaction">;
  } | null;
  readonly " $fragmentType": "GetHelpZendeskContactBuyer_viewer";
};
export type GetHelpZendeskContactBuyer_viewer$key = {
  readonly " $data"?: GetHelpZendeskContactBuyer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskContactBuyer_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasOrderId"
    },
    {
      "kind": "RootArgument",
      "name": "hasSellerId"
    },
    {
      "kind": "RootArgument",
      "name": "transactionId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "GetHelpZendeskContactBuyer_viewer",
  "selections": [
    {
      "condition": "hasOrderId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "transactionId",
              "variableName": "transactionId"
            }
          ],
          "concreteType": "Transaction",
          "kind": "LinkedField",
          "name": "transaction",
          "plural": false,
          "selections": [
            {
              "condition": "hasSellerId",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ContactBuyerForm_transaction"
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Conversation",
              "kind": "LinkedField",
              "name": "conversation",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Item",
              "kind": "LinkedField",
              "name": "item",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "buyer",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": "mcRedactionOpopAbTest",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "testName",
                      "value": "MC_removeRedactionOPOP_Mar2026"
                    }
                  ],
                  "concreteType": "AbTestConfigV2UserVariant",
                  "kind": "LinkedField",
                  "name": "abTestV2",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "variant",
                      "storageKey": null
                    }
                  ],
                  "storageKey": "abTestV2(testName:\"MC_removeRedactionOPOP_Mar2026\")"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "a2e031c48800d1481cb23ab2065bfc62";

export default node;
